import { DEMO_USER } from '../siteConfig.js';

const now = Date.now();
const day = 86400000;
const ts = (offsetDays = 0) => ({
  seconds: Math.floor((now + offsetDays * day) / 1000),
  nanoseconds: 0,
  toDate: () => new Date(now + offsetDays * day),
});

export function createInitialDemoStore() {
  return {
    owners: {
      'lot-101': {
        address: '101 Summit View Drive',
        tract: '101',
        name1: 'Alex Morgan',
        name2: 'Sam Morgan',
        mailing_address: '101 Summit View Drive, Pine Ridge, NC 28789',
        phone1: '(828) 555-0142',
        phone2: '(828) 555-0143',
        email1: 'owner@pineridge.demo',
        email2: 'sam.morgan@example.com',
        OwnerId: DEMO_USER.uid,
      },
      'lot-204': {
        address: '204 Cedar Knoll Lane',
        tract: '204',
        name1: 'Taylor Brooks',
        name2: '',
        mailing_address: '204 Cedar Knoll Lane, Pine Ridge, NC 28789',
        phone1: '(828) 555-0198',
        phone2: '',
        email1: 'taylor.brooks@example.com',
        email2: '',
        OwnerId: 'demo-owner-002',
      },
      'lot-318': {
        address: '318 Hemlock Ridge Road',
        tract: '318',
        name1: 'Riley Chen',
        name2: 'Jordan Chen',
        mailing_address: '318 Hemlock Ridge Road, Pine Ridge, NC 28789',
        phone1: '(828) 555-0167',
        phone2: '(828) 555-0168',
        email1: 'riley.chen@example.com',
        email2: 'jordan.chen@example.com',
        OwnerId: 'demo-owner-003',
      },
    },
    events: {
      'spring-community-day-2026-07-12': {
        title: 'Spring Community Day & Trail Cleanup',
        date: '2026-07-12',
        time: '09:00',
        start: ts(14),
        location: 'Community Pavilion',
        description: 'Volunteer trail maintenance, coffee, and board Q&A.',
        category: 'community',
        source: 'Pine Ridge Estates HOA',
      },
      'board-meeting-2026-07-22': {
        title: 'Monthly Board Meeting',
        date: '2026-07-22',
        time: '18:30',
        start: ts(24),
        location: 'HOA Clubhouse',
        description: 'Open session at 18:30; executive session follows.',
        category: 'meeting',
        source: 'Pine Ridge Estates HOA',
      },
      'fall-foliage-social-2026-10-18': {
        title: 'Fall Foliage Social',
        date: '2026-10-18',
        time: '16:00',
        start: ts(110),
        location: 'Overlook Deck',
        description: 'Potluck, acoustic music, and sunset viewing.',
        category: 'social',
        source: 'Social Committee',
      },
    },
    arc_requests: {
      'arc-deck-101': {
        lotId: 'lot-101',
        projectType: 'deck',
        title: 'Rear deck expansion',
        description: 'Extend existing deck by 8 ft using composite decking, matching current railing style.',
        status: 'under_review',
        photoUrls: ['/assets/demo/hemlock.jpg'],
        adminNotes: 'Please confirm setback distance from property line.',
        submittedBy: 'demo-owner-001',
        submittedByEmail: 'owner@pineridge.demo',
        createdAt: ts(-7),
        updatedAt: ts(-2),
      },
      'arc-fence-204': {
        lotId: 'lot-204',
        projectType: 'fence',
        title: 'Side yard privacy fence',
        description: '6 ft cedar privacy fence along east property line, natural stain.',
        status: 'approved',
        photoUrls: ['/assets/demo/garden.jpg'],
        adminNotes: 'Approved — match community fence height and stain guidelines.',
        submittedBy: 'demo-owner-002',
        submittedByEmail: 'taylor.brooks@example.com',
        createdAt: ts(-30),
        updatedAt: ts(-12),
        reviewedAt: ts(-12),
        reviewedBy: 'demo-admin-001',
      },
    },
    violations: {
      'violation-landscape-101': {
        lotId: 'lot-101',
        title: 'Landscaping maintenance',
        description: 'Front beds need seasonal trimming per community standards.',
        status: 'open',
        createdAt: ts(-3),
        createdBy: 'demo-admin-001',
      },
      'violation-parking-204': {
        lotId: 'lot-204',
        title: 'Guest parking duration',
        description: 'Vehicle exceeded 72-hour guest parking limit on Hemlock Ridge.',
        status: 'resolved',
        createdAt: ts(-20),
        createdBy: 'demo-admin-001',
        resolvedAt: ts(-5),
        resolvedBy: 'demo-admin-001',
      },
    },
    polls: {
      'pool-hours-2026': {
        question: 'Extend community pool hours through Labor Day?',
        options: [
          { text: 'Yes — open until 9 PM on weekends', votes: 18 },
          { text: 'No — keep current hours', votes: 7 },
          { text: 'Abstain', votes: 2 },
        ],
        status: 'open',
        startTime: ts(-10),
        endTime: ts(20),
      },
      'paving-project-2025': {
        question: 'Approve Phase 2 road resurfacing assessment?',
        options: [
          { text: 'Approve $1,200 special assessment', votes: 31 },
          { text: 'Defer to 2027 budget', votes: 9 },
        ],
        status: 'closed',
        startTime: ts(-120),
        endTime: ts(-30),
      },
    },
    'polls/pool-hours-2026/votes': {
      'lot-101': { optionIndex: 0, votedBy: DEMO_USER.uid, votedAt: ts(-2) },
    },
    message_board: {
      'post-welcome': {
        title: 'Welcome new owners on Cedar Knoll',
        content: 'Please join us Saturday for coffee at the pavilion. Bring questions for the board.',
        authorId: 'demo-admin-001',
        authorEmail: 'admin@pineridge.demo',
        createdAt: ts(-5),
        updatedAt: ts(-5),
      },
      'post-trash': {
        title: 'Bear-proof bin reminder',
        content: 'Bins must be latched before dusk. Wildlife activity has increased on Hemlock Ridge.',
        authorId: 'demo-owner-002',
        authorEmail: 'taylor.brooks@example.com',
        createdAt: ts(-2),
        updatedAt: ts(-2),
      },
    },
    'message_board/post-welcome/replies': {
      reply1: {
        content: 'Looking forward to it — we just closed on lot 204.',
        authorId: 'demo-owner-002',
        authorEmail: 'taylor.brooks@example.com',
        createdAt: ts(-4),
      },
    },
    contractors: {
      c1: {
        businessName: 'Blue Ridge Tree Care',
        contactName: 'Morgan Ellis',
        phoneNumber: '(828) 555-0100',
        notes: 'Preferred for storm cleanup and lot clearing.',
        averageRating: 4.8,
        ratingCount: 6,
        externalRatingLinks: [
          { site: 'google', label: 'Google', url: 'https://www.google.com/maps/search/?api=1&query=Blue+Ridge+Tree+Care+Macon+County+NC' },
          { site: 'yelp', label: 'Yelp', url: 'https://www.yelp.com/biz/blue-ridge-tree-care-macon-county' },
        ],
        externalRatingLinksUpdatedAt: ts(-1),
      },
      c2: {
        businessName: 'Summit HVAC & Plumbing',
        contactName: 'Chris Patel',
        phoneNumber: '(828) 555-0125',
        notes: '24/7 emergency line for absentee owners.',
        averageRating: 4.2,
        ratingCount: 4,
        externalRatingLinks: [
          { site: 'google', label: 'Google', url: 'https://www.google.com/maps/search/?api=1&query=Summit+HVAC+Plumbing+Macon+County+NC' },
          { site: 'angi', label: 'Angi', url: 'https://www.angi.com/companylist/us/nc/macon/summit-hvac-plumbing.htm' },
        ],
        externalRatingLinksUpdatedAt: ts(-1),
      },
      c3: {
        businessName: 'Highland Stone & Landscape',
        contactName: 'Jamie Ortiz',
        phoneNumber: '(828) 555-0180',
        notes: 'Retaining walls, driveways, native plantings.',
        averageRating: 3.6,
        ratingCount: 3,
        externalRatingLinks: [
          { site: 'bbb', label: 'BBB', url: 'https://www.bbb.org/us/nc/macon/profile/landscape-contractors/highland-stone-landscape-0000' },
        ],
        externalRatingLinksUpdatedAt: ts(-2),
      },
    },
    rentals: {
      r1: {
        address: '204 Cedar Knoll Lane',
        ownerName: 'Taylor Brooks',
        phone: '(828) 555-0198',
        email: 'taylor.brooks@example.com',
        description: '3BR mountain cottage with long-range views. Weekly minimum in peak season.',
        rate: '$285/night',
      },
    },
    board_members: {
      bm1: { name: 'Jordan Lee', role: 'President', term: '2024–2026' },
      bm2: { name: 'Casey Nguyen', role: 'Treasurer', term: '2025–2027' },
      bm3: { name: 'Morgan Ellis', role: 'Secretary', term: '4–2026' },
    },
    emergency_alerts: {
      active_alert: {
        message: '',
        createdAt: ts(-1),
        createdBy: 'demo-admin-001',
      },
    },
    community_well: {
      current: {
        flowGPM: 12.4,
        dailyTotalGallons: 18420,
        signalQuality: 'Good',
        lastUpdated: ts(0),
      },
    },
    'community_well/readings': {
      r1: { flowGPM: 11.8, dailyTotalGallons: 17650, recordedAt: ts(-1) },
      r2: { flowGPM: 12.1, dailyTotalGallons: 18100, recordedAt: ts(-2) },
      r3: { flowGPM: 12.4, dailyTotalGallons: 18420, recordedAt: ts(0) },
    },
    'community_well/filter_changes': {
      f1: { changedAt: ts(-45), notes: 'Sediment pre-filter replaced' },
    },
    road_conditions: {
      subdivision: {
        description: 'Main loop is clear. Gate approach has light gravel wash — crews scheduled Thursday.',
        updatedAt: ts(0),
        images: [],
      },
    },
    weather_alerts: {},
    flora: {
      f1: {
        commonName: 'Eastern Hemlock',
        scientificName: 'Tsuga canadensis',
        notes: 'Mature specimen near lot 101 driveway.',
        imageUrl: '/assets/demo/hemlock.jpg',
        identifiedBy: 'owner@pineridge.demo',
        createdAt: ts(-8),
      },
    },
    fauna: {
      a1: {
        commonName: 'White-tailed Deer',
        scientificName: 'Odocoileus virginianus',
        notes: 'Doe and fawn near community garden at dusk.',
        imageUrl: '/assets/demo/deer.jpg',
        identifiedBy: 'taylor.brooks@example.com',
        createdAt: ts(-3),
      },
    },
    minerals: {
      m1: {
        commonName: 'Mica schist',
        scientificName: 'Schist with muscovite',
        notes: 'Glittering foliation typical of local basement rock.',
        imageUrl: '/assets/demo/schist.jpg',
        identifiedBy: 'riley.chen@example.com',
        createdAt: ts(-6),
      },
    },
    community_photos: {
      p1: {
        title: 'Sunrise over the ridgeline',
        uploadedBy: 'owner@pineridge.demo',
        imageUrl: '/assets/demo/sunrise.jpg',
        createdAt: ts(-7),
      },
      p2: {
        title: 'Community garden in bloom',
        uploadedBy: 'taylor.brooks@example.com',
        imageUrl: '/assets/demo/garden.jpg',
        createdAt: ts(-4),
      },
    },
    lotImages: {
      'lot-101': { imageUrl: '/assets/demo/lot-101.jpg', tract: '101' },
      'lot-204': { imageUrl: '/assets/demo/lot-204.jpg', tract: '204' },
    },
    user_preferences: {
      [DEMO_USER.uid]: {
        emailOnMessageReply: true,
        emailOnFileUpload: true,
        emailOnEmergency: true,
        emailOnSiteUpdate: false,
      },
    },
  };
}

export const DEMO_CALLABLE_RESPONSES = {
  getInvoices: {
    invoices: [
      {
        id: 'inv-2026-q2',
        lotId: 'lot-101',
        tract: '101',
        amount: 85000,
        amountDisplay: '$850.00',
        status: 'open',
        displayStatus: 'open',
        description: 'Q2 2026 HOA Assessment',
        dueDate: '2026-07-15',
        isPayable: true,
      },
      {
        id: 'inv-2026-q1',
        lotId: 'lot-101',
        tract: '101',
        amount: 85000,
        amountDisplay: '$850.00',
        status: 'paid',
        displayStatus: 'paid',
        description: 'Q1 2026 HOA Assessment',
        dueDate: '2026-04-15',
        isPayable: false,
      },
    ],
  },
  getComplianceDashboard: {
    success: true,
    fiscalYear: 2026,
    healthScore: 82,
    disclaimer: 'Checklist tool only — confirm deadlines with your attorney, bylaws, and state statutes.',
    config: { state: 'NC', fiscalYearStartMonth: 1, defaultMeetingNoticeDays: 14, electionCycleYears: 1 },
    counts: { overdue: 0, dueSoon: 2, completed: 8, total: 13, upcomingMeetings: 2, noticeGaps: 0, activeElections: 1 },
    overdue: [],
    dueSoon: [
      { id: 'obl-demo-1', title: 'Annual member meeting', dueDate: new Date(now + 18 * day).toISOString(), category: 'meetings' },
      { id: 'obl-demo-2', title: 'Master insurance policy renewal', dueDate: new Date(now + 25 * day).toISOString(), category: 'insurance' },
    ],
    upcomingMeetings: [
      {
        id: 'mtg-demo-1',
        title: 'Q3 Board Meeting',
        type: 'regular_board',
        scheduledAt: new Date(now + 21 * day).toISOString(),
        location: 'HOA Clubhouse',
        noticeCompliant: true,
        status: 'scheduled',
      },
    ],
    noticeGaps: [],
    activeElections: [
      {
        id: 'el-demo-1',
        title: '2026 Board Election',
        electionDate: new Date(now + 45 * day).toISOString(),
        status: 'nominations_open',
      },
    ],
  },
  getComplianceConfig: {
    success: true,
    config: { state: 'NC', fiscalYearStartMonth: 1, defaultMeetingNoticeDays: 14, electionCycleYears: 1, communityType: 'planned_community' },
    disclaimer: 'Checklist tool only — confirm deadlines with your attorney, bylaws, and state statutes.',
  },
  getComplianceTemplates: {
    success: true,
    templates: [
      { id: 'annual-member-meeting', title: 'Annual member meeting', category: 'meetings' },
      { id: 'board-election', title: 'Board of directors election', category: 'elections' },
    ],
    categories: ['meetings', 'elections', 'financial', 'insurance', 'records', 'taxes', 'other'],
    meetingTypes: ['annual', 'regular_board', 'special', 'budget', 'executive_session'],
    electionStatuses: ['planning', 'nominations_open', 'voting', 'certified', 'cancelled'],
    disclaimer: 'Checklist tool only — confirm deadlines with your attorney, bylaws, and state statutes.',
  },
  listComplianceObligations: {
    success: true,
    obligations: [
      {
        id: 'obl-demo-1',
        title: 'Annual member meeting',
        category: 'meetings',
        description: 'Hold the annual meeting of members per bylaws.',
        dueDate: new Date(now + 18 * day).toISOString(),
        status: 'due_soon',
        legalReference: 'Bylaws',
        completedAt: null,
        waived: false,
      },
      {
        id: 'obl-demo-2',
        title: 'Board of directors election',
        category: 'elections',
        dueDate: new Date(now + 45 * day).toISOString(),
        status: 'upcoming',
        legalReference: 'Bylaws',
        completedAt: null,
        waived: false,
      },
    ],
  },
  listMeetings: {
    success: true,
    meetings: [
      {
        id: 'mtg-demo-1',
        type: 'regular_board',
        title: 'Q3 Board Meeting',
        scheduledAt: new Date(now + 21 * day).toISOString(),
        location: 'HOA Clubhouse',
        noticeSentAt: new Date(now - 7 * day).toISOString(),
        noticeDaysRequired: 14,
        noticeCompliant: true,
        status: 'scheduled',
        openToOwners: true,
      },
      {
        id: 'mtg-demo-2',
        type: 'annual',
        title: 'Annual Member Meeting',
        scheduledAt: new Date(now + 60 * day).toISOString(),
        location: 'Community Pavilion',
        noticeSentAt: null,
        noticeDaysRequired: 14,
        noticeCompliant: null,
        status: 'scheduled',
        openToOwners: true,
      },
    ],
  },
  listElections: {
    success: true,
    elections: [
      {
        id: 'el-demo-1',
        title: '2026 Board Election',
        electionDate: new Date(now + 45 * day).toISOString(),
        nominationDeadline: new Date(now + 30 * day).toISOString(),
        positions: [{ title: 'President', termYears: 2 }, { title: 'Treasurer', termYears: 2 }],
        ballotMethod: 'in_person',
        status: 'nominations_open',
        results: [],
        certifiedAt: null,
      },
    ],
  },
  getPublicComplianceCalendar: {
    success: true,
    disclaimer: 'Checklist tool only — confirm deadlines with your attorney, bylaws, and state statutes.',
    meetings: [
      {
        id: 'mtg-demo-1',
        type: 'regular_board',
        title: 'Q3 Board Meeting',
        scheduledAt: new Date(now + 21 * day).toISOString(),
        location: 'HOA Clubhouse',
        agendaUrl: '',
        openToOwners: true,
        status: 'scheduled',
      },
      {
        id: 'mtg-demo-2',
        type: 'annual',
        title: 'Annual Member Meeting',
        scheduledAt: new Date(now + 60 * day).toISOString(),
        location: 'Community Pavilion',
        openToOwners: true,
        status: 'scheduled',
      },
    ],
    elections: [
      {
        id: 'el-demo-1',
        title: '2026 Board Election',
        electionDate: new Date(now + 45 * day).toISOString(),
        nominationDeadline: new Date(now + 30 * day).toISOString(),
        positions: [{ title: 'President', termYears: 2 }],
        ballotMethod: 'in_person',
        status: 'nominations_open',
      },
    ],
  },
  generateComplianceObligations: { success: true, fiscalYear: 2026, created: 13 },
  upsertComplianceObligation: { success: true, obligationId: 'obl-demo-new' },
  completeComplianceObligation: { success: true },
  upsertMeeting: { success: true, meetingId: 'mtg-demo-new' },
  recordMeetingHeld: { success: true },
  upsertElection: { success: true, electionId: 'el-demo-new' },
  certifyElection: { success: true },
  updateComplianceConfig: {
    success: true,
    config: { state: 'NC', fiscalYearStartMonth: 1, defaultMeetingNoticeDays: 14, electionCycleYears: 1 },
  },
  getFinanceDashboard: {
    success: true,
    cashCents: 4285000,
    cashDisplay: '$42,850.00',
    apOutstandingCents: 185000,
    apOutstandingDisplay: '$1,850.00',
    pendingApprovalCount: 1,
    openBillCount: 2,
    paidYtdCents: 1240000,
    paidYtdDisplay: '$12,400.00',
    bankAccountCount: 2,
    recentPayments: [
      {
        id: 'vp-demo-1',
        contractorName: 'Blue Ridge Tree Care',
        amountCents: 62000,
        amountDisplay: '$620.00',
        paymentMethod: 'check',
        paidAt: new Date(now - 5 * day).toISOString(),
      },
    ],
    billsByStatus: { draft: 0, pending_approval: 1, approved: 1, paid: 3, void: 0 },
  },
  listBankAccounts: {
    success: true,
    accounts: [
      {
        id: 'bank-demo-op',
        nickname: 'Operating Checking',
        institution: 'First Citizens',
        accountType: 'checking',
        lastFour: '4521',
        balanceCents: 3850000,
        balanceDisplay: '$38,500.00',
        balanceAsOf: new Date(now).toISOString(),
        isPrimary: true,
        connectionType: 'manual',
        notes: 'Primary HOA operating account',
      },
      {
        id: 'bank-demo-res',
        nickname: 'Reserve Savings',
        institution: 'First Citizens',
        accountType: 'reserve',
        lastFour: '8834',
        balanceCents: 435000,
        balanceDisplay: '$4,350.00',
        balanceAsOf: new Date(now - 2 * day).toISOString(),
        isPrimary: false,
        connectionType: 'manual',
        notes: 'Capital reserve',
      },
    ],
  },
  listVendorBills: () => ({
    success: true,
    bills: [
      {
        id: 'bill-demo-1',
        contractorId: 'c1',
        contractorName: 'Blue Ridge Tree Care',
        invoiceNumber: 'BR-2044',
        description: 'Spring storm cleanup — common areas',
        category: 'landscaping',
        amountCents: 185000,
        amountDisplay: '$1,850.00',
        dueDate: '2026-07-10',
        status: 'approved',
        notes: 'Board approved at June meeting',
        createdAt: new Date(now - 12 * day).toISOString(),
        approvedAt: new Date(now - 3 * day).toISOString(),
        paidAt: null,
      },
      {
        id: 'bill-demo-2',
        contractorId: 'c2',
        contractorName: 'Summit HVAC & Plumbing',
        invoiceNumber: 'SH-1182',
        description: 'Clubhouse AC seasonal service',
        category: 'maintenance',
        amountCents: 94000,
        amountDisplay: '$940.00',
        dueDate: '2026-07-20',
        status: 'pending_approval',
        notes: '',
        createdAt: new Date(now - 2 * day).toISOString(),
        approvedAt: null,
        paidAt: null,
      },
    ],
  }),
  listVendorPayments: {
    success: true,
    payments: [
      {
        id: 'vp-demo-1',
        billId: 'bill-demo-paid',
        contractorName: 'Blue Ridge Tree Care',
        amountCents: 62000,
        amountDisplay: '$620.00',
        paymentMethod: 'check',
        checkNumber: '1042',
        bankAccountNickname: 'Operating Checking',
        paidAt: new Date(now - 5 * day).toISOString(),
        memo: 'Lot line clearing',
      },
    ],
  },
  upsertBankAccount: { success: true, accountId: 'bank-demo-op' },
  recordBankBalance: { success: true, balanceCents: 3850000, balanceDisplay: '$38,500.00' },
  upsertVendorBill: { success: true, billId: 'bill-demo-new' },
  updateVendorBillStatus: { success: true },
  recordVendorPayment: { success: true, paymentId: 'vp-demo-new', amountDisplay: '$1,850.00' },
  getPaymentMethods: {
    paymentMethodsByLot: [
      {
        lotId: 'lot-101',
        tract: '101',
        paymentMethods: [
          { id: 'pm_demo_visa', brand: 'visa', last4: '4242', expMonth: 12, expYear: 2028, isDefault: true },
        ],
      },
    ],
  },
  getGatePlates: {
    lots: [{ lotId: 'lot-101', tract: '101', address: '101 Summit View Drive' }],
    plates: [
      { id: 'plate-1', plate: 'PRD101', label: 'Alex — Subaru', type: 'owner', lotId: 'lot-101', active: true },
      { id: 'plate-2', plate: 'GUEST01', label: 'Guest SUV', type: 'guest', lotId: 'lot-101', active: true },
    ],
  },
  getGateAccessLog: {
    logs: [
      { plate: 'PRD101', result: 'granted', timestamp: ts(0), source: 'LPR' },
      { plate: 'GUEST01', result: 'granted', timestamp: ts(-1), source: 'LPR' },
      { plate: 'UNK999', result: 'denied', timestamp: ts(-2), source: 'LPR' },
      { plate: 'PRD101', result: 'manual_open', timestamp: ts(-3), source: 'app' },
    ],
  },
  getMailboxHistory: {
    history: [
      { date: '2026-06-27', delivered: true, carriers: ['USPS'], deliveries: 1 },
      { date: '2026-06-26', delivered: true, carriers: ['USPS', 'UPS'], deliveries: 2 },
      { date: '2026-06-25', delivered: false, carriers: [], deliveries: 0 },
    ],
    carrierMeta: { USPS: { color: '#004B87' }, UPS: { color: '#351C15' } },
  },
  getMailboxStatus: {
    today: { date: '2026-06-27', delivered: true, deliveries: [{ carrier: 'USPS', time: '14:22' }] },
    configured: true,
  },
  getVehicleLog: {
    groups: [
      {
        id: 'vg-demo-1',
        plate: 'PRD101',
        make: 'Subaru',
        model: 'Outback',
        color: 'Green',
        sightingCount: 12,
        thumbnailUrl: '/assets/demo/demo-white-subaru.jpg',
        gateAccessLotId: 'lot-101',
      },
      {
        id: 'vg-demo-2',
        plate: 'NCVISIT',
        make: 'Ford',
        model: 'F-150',
        color: 'Blue',
        sightingCount: 3,
        thumbnailUrl: '/assets/demo/demo-blue-f150.jpg',
        gateAccessLotId: null,
      },
    ],
    sightings: [],
  },
  searchLocalNews: {
    news: [
      {
        title: 'Mountain counties see record spring tourism',
        date: '2026-06-25',
        description: 'Vacation rentals and outdoor outfitters report strong bookings through July.',
        url: '#',
        source: 'MOUNTAIN TIMES',
      },
      {
        title: 'Wildlife officials remind residents about bear-aware trash practices',
        date: '2026-06-24',
        description: 'Increased bear activity reported across elevation communities.',
        url: '#',
        source: 'REGIONAL HERALD',
      },
      {
        title: 'Road resurfacing grants available for private communities',
        date: '2026-06-22',
        description: 'State program opens applications for HOAs with shared road maintenance.',
        url: '#',
        source: 'CIVIC WATCH',
      },
    ],
  },
  searchLocalEvents: {
    events: [
      { name: 'Community Pool Opening Weekend', date: '2026-07-05', location: 'Pine Ridge Clubhouse', category: 'social' },
      { name: 'Guided Wildflower Walk', date: '2026-07-19', location: 'Ridgeline Trailhead', category: 'outdoor' },
    ],
  },
  listAllUsers: {
    users: [
      { uid: 'demo-owner-001', email: 'owner@pineridge.demo', lots: ['101'] },
      { uid: 'demo-admin-001', email: 'admin@pineridge.demo', lots: [], isAdmin: true },
    ],
  },
  getAllInvoices: {
    invoices: [
      { id: 'inv-2026-q2', lotId: 'lot-101', tract: '101', amount: 85000, status: 'open' },
      { id: 'inv-2026-q2-204', lotId: 'lot-204', tract: '204', amount: 85000, status: 'open' },
    ],
  },
  getAdminOpsSnapshot: {
    snapshot: {
      generatedAt: new Date().toISOString(),
      projectId: 'pineridge-estates-demo',
      region: 'us-central1',
      functions: { runtime: 'nodejs22', hostingTargets: ['demo'] },
      overview: {
        ownerLots: 3,
        platformAdmins: 1,
        totalFirestoreDocsSampled: 42,
        openPolls: 1,
      },
      signals: [
        { id: 'ring_mailbox', label: 'Ring mailbox', value: 'Linked', severity: 'ok', hint: 'Demo Ring integration active' },
        { id: 'vehicle_sightings', label: 'Vehicle sightings (24h)', value: '4', severity: 'ok', hint: 'Gate and mailbox camera pipeline' },
        { id: 'gate_denials', label: 'Gate denials (recent sample)', value: '1', severity: 'ok', hint: 'From latest gate_access_log sample' },
        { id: 'emergency_banner', label: 'Emergency banner', value: 'Clear', severity: 'ok', hint: 'Community-wide alert strip' },
        { id: 'open_polls', label: 'Open polls', value: '1', severity: 'info', hint: 'Active owner votes' },
      ],
      firestore: {
        databaseId: 'demo',
        totalDocsSampled: 42,
        collections: [
          { name: 'owners', count: 3, truncated: false },
          { name: 'invoices', count: 4, truncated: false },
          { name: 'polls', count: 2, truncated: false },
          { name: 'events', count: 3, truncated: false },
          { name: 'vehicle_groups', count: 2, truncated: false },
        ],
      },
      dailyScan: {
        lastReport: {
          generatedAt: new Date(now - 3600000).toISOString(),
          summary: { total: 1, warning: 0, info: 1 },
          findings: [
            {
              id: 'demo-scan-ok',
              title: 'Demo environment healthy',
              category: 'demo',
              detail: 'All sampled collections within expected demo ranges.',
              remediation: 'No action required in demo mode.',
              severity: 'info',
            },
          ],
        },
      },
      recentLogs: {
        lookbackHours: 2,
        unavailable: true,
        hint: 'Cloud Logging is not available in the demo build.',
        entries: [],
      },
      debugLinks: [
        { title: 'Firebase Hosting', href: 'https://console.firebase.google.com/' },
        { title: 'Firestore', href: 'https://console.cloud.google.com/firestore' },
      ],
    },
  },
  getScheduledJobsStatus: {
    snapshot: {
      generatedAt: new Date().toISOString(),
      jobs: [
        {
          id: 'clean_old_cache',
          name: 'Identification cache purge',
          functionName: 'cleanOldCache',
          schedule: 'Every 24 hours',
          lastRun: { lastRunAt: new Date(now - 7200000).toISOString(), lastStatus: 'ok', lastSummary: 'Cleaned 0 old cache entries' },
        },
        {
          id: 'sync_local_events',
          name: 'Calendar events sync',
          functionName: 'syncLocalEvents',
          schedule: 'Daily 06:00 UTC',
          lastRun: { lastRunAt: new Date(now - 86400000).toISOString(), lastStatus: 'ok', lastSummary: 'added=2, skipped=0' },
        },
        {
          id: 'scheduled_watcher',
          name: 'Platform watcher',
          functionName: 'scheduledWatcher',
          schedule: 'Every 30 minutes',
          lastRun: { lastRunAt: new Date(now - 1800000).toISOString(), lastStatus: 'ok', lastSummary: 'opened=0, resolved=0' },
        },
      ],
    },
  },
  getWatcherIncidents: {
    incidents: [
      {
        id: 'signal-mailbox-unconfigured',
        title: 'Mailbox monitoring not configured',
        summary: 'Demo incident — resolves automatically when Ring is linked.',
        severity: 'warning',
        source: 'ops_signal',
        status: 'resolved',
        updatedAt: new Date(now - 86400000).toISOString(),
        createdAt: new Date(now - 172800000).toISOString(),
      },
    ],
  },
  runWatcherCheckFn: (data) => ({
    summary: { opened: 0, resolved: 0, checkedAt: new Date().toISOString() },
    incidents: DEMO_CALLABLE_RESPONSES.getWatcherIncidents.incidents,
  }),
  resolveWatcherIncident: { success: true },
  runDailyScan: {
    report: {
      generatedAt: new Date().toISOString(),
      summary: { total: 1, warning: 0, info: 1 },
      findings: [
        {
          id: 'demo-scan-run',
          title: 'Demo scan complete',
          category: 'demo',
          detail: 'On-demand scan finished successfully.',
          remediation: 'Review findings in Firebase Ops.',
          severity: 'info',
        },
      ],
    },
  },
  submitHoaLead: () => ({
    success: true,
    leadId: 'demo-lead-001',
    message: 'Thanks! Your requirements brief was received (demo mode).',
  }),
  submitSmsAlert: () => ({
    ok: true,
    logId: 'demo-sms-001',
    status: 'stub_logged',
    liveMode: false,
    sentCount: 0,
    failedCount: 0,
    message: 'SMS alert logged (demo mode — Twilio not configured).',
  }),
  listWorkOrders: () => ({
    success: true,
    orders: [
      { id: 'wo-demo-1', lotId: 'lot-101', title: 'Deck railing repair', status: 'submitted', category: 'maintenance', createdAt: new Date().toISOString() },
    ],
  }),
  listVisitorRegistrations: () => ({
    success: true,
    visitors: [
      { id: 'vis-demo-1', lotId: 'lot-101', guestName: 'Alex Guest', plate: 'NC-DEMO1', status: 'active', visitEnd: new Date(Date.now() + 86400000).toISOString() },
    ],
  }),
  listAmenityResources: () => ({
    success: true,
    resources: [
      { id: 'amen-club', name: 'Clubhouse', description: 'Main gathering room', maxHours: 4, active: true },
      { id: 'amen-pool', name: 'Pool pavilion', description: 'Reserved pool area', maxHours: 3, active: true },
    ],
  }),
  listAmenityReservations: () => ({
    success: true,
    reservations: [
      {
        id: 'res-demo-1',
        resourceId: 'amen-club',
        resourceName: 'Clubhouse',
        lotId: 'lot-101',
        startAt: new Date(Date.now() + 86400000).toISOString(),
        endAt: new Date(Date.now() + 90000000).toISOString(),
        status: 'confirmed',
      },
    ],
  }),
  listParkingPermits: () => ({
    success: true,
    permits: [
      { id: 'park-demo-1', lotId: 'lot-101', plate: 'NC-GUEST', permitType: 'guest', status: 'active' },
    ],
  }),
  listClassifieds: () => ({
    success: true,
    listings: [
      { id: 'cls-demo-1', title: 'Kayak — barely used', description: '14 ft sit-on-top, pickup at lot 101.', price: '450', status: 'published', category: 'general' },
    ],
  }),
  listEsignDocuments: () => ({
    success: true,
    documents: [
      { id: 'esign-demo-1', title: '2026 parking policy acknowledgment', description: 'Please review updated guest parking rules.', status: 'open', signatureCount: 12 },
    ],
  }),
  getEnvironmentalDashboard: () => ({
    success: true,
    generatedAt: new Date().toISOString(),
    airQuality: { aqi: 42, category: 'Good', pm25: 8.2, source: 'demo', color: '#00e400' },
    wildfire: { level: 'low', label: 'Low', advice: 'Normal precautions for mountain communities.' },
    alerts: [],
    links: [{ label: 'NC Forest Service fire map', href: 'https://www.ncforestservice.gov/fire_control/fires.htm' }],
    disclaimer: 'Demo environmental readings — configure PurpleAir in production.',
  }),
  getOperationsDashboard: () => ({
    success: true,
    summary: { openWorkOrders: 1, pendingReservations: 0, activeVisitors: 1, pendingPermits: 0, pendingClassifieds: 0, openEsignDocs: 0 },
  }),
  getMyContractorRatings: () => ({
    success: true,
    ratings: { c1: { stars: 5, comment: 'Fast storm cleanup after the last ice event.', updatedAt: new Date().toISOString() } },
  }),
  listContractorRatings: (data) => {
    const id = data?.contractorId || 'c1';
    const samples = {
      c1: [
        { id: 'c1-demo-1', contractorId: 'c1', stars: 5, comment: 'Fast storm cleanup after the last ice event.', updatedAt: new Date().toISOString() },
        { id: 'c1-demo-2', contractorId: 'c1', stars: 5, comment: 'Professional crew, left the lot spotless.', updatedAt: new Date(Date.now() - 86400000 * 12).toISOString() },
      ],
      c2: [
        { id: 'c2-demo-1', contractorId: 'c2', stars: 4, comment: 'Fixed our heat pump same day.', updatedAt: new Date().toISOString() },
      ],
      c3: [
        { id: 'c3-demo-1', contractorId: 'c3', stars: 4, comment: 'Great retaining wall work.', updatedAt: new Date().toISOString() },
      ],
    };
    const ratings = samples[id] || [];
    const agg = { c1: { averageRating: 4.8, ratingCount: 6 }, c2: { averageRating: 4.2, ratingCount: 4 }, c3: { averageRating: 3.6, ratingCount: 3 } };
    return { success: true, ratings, ...(agg[id] || { averageRating: 0, ratingCount: 0 }) };
  },
  submitContractorRating: (data) => ({
    success: true,
    ratingId: `demo-${data?.contractorId || 'c1'}`,
    stars: data?.stars || 5,
    averageRating: 4.5,
    ratingCount: 5,
  }),
  deleteContractorRating: () => ({ success: true, averageRating: 4.2, ratingCount: 4 }),
  getRiverData: () => {
    const now = Date.now();
    const buildSeries = (baseLevel, baseFlow) => {
      const levels = [];
      const flows = [];
      for (let i = 48; i >= 0; i -= 1) {
        const time = new Date(now - i * 3 * 60 * 60 * 1000).toISOString();
        levels.push({ time, value: baseLevel + Math.sin(i / 6) * 0.15 });
        flows.push({ time, value: baseFlow + Math.sin(i / 5) * 40 });
      }
      return {
        levels,
        flows,
        latestLevel: levels[levels.length - 1],
        latestFlow: flows[flows.length - 1],
      };
    };
    const rivers = {
      '02177000': { name: 'Chattooga River', siteId: '02177000', ...buildSeries(2.1, 420) },
      '03505550': { name: 'Nantahala River', siteId: '03505550', ...buildSeries(1.8, 680) },
      '0351706800': { name: 'Cheoah River', siteId: '0351706800', ...buildSeries(1.2, 310) },
      '03513000': { name: 'Tuckaseegee River', siteId: '03513000', ...buildSeries(2.4, 540) },
      '03550000': { name: 'Valley River', siteId: '03550000', ...buildSeries(1.6, 390) },
    };
    return { success: true, generatedAt: new Date().toISOString(), rivers };
  },
  nannyAssistantFn: (data) => {
    const msg = String(data?.message || '').toLowerCase();
    if (/\b(open|unlock)\s+(the\s+)?gate\b|\blet me in\b/.test(msg)) {
      return {
        reply: 'Opening the gate for you now. (Demo mode — logged only.)',
        configured: true,
        actionTaken: { type: 'open_gate', success: true, simulated: true },
        navigation: null,
      };
    }
    if (/\b(who are you|your name|why.*nanny|called nanny|named nanny)\b/.test(msg)) {
      return {
        reply: 'I\'m Nanny, named after the Nantahala River near our community. "Nantahala" is Cherokee — often "land of the noonday sun" — for the gorge where sunlight hits the river mainly at midday. Ask me about Nantahala history or any portal page.',
        configured: true,
        actionTaken: null,
        navigation: null,
      };
    }
    if (/\b(nantahala|nanthala).*(history|mean|cherokee|gorge)|history of nantahala|about nantahala|noonday sun\b/.test(msg)) {
      return {
        reply: 'Nantahala names the river and gorge in western NC — Cherokee origin, famous for whitewater and the Nantahala National Forest (1920). The community sits in that mountain watershed. See Local River Info (/local-river-info) for current conditions.',
        configured: true,
        actionTaken: null,
        navigation: null,
      };
    }
    const portalHints = [
      { match: /flight\s*radar|aircraft|planes/, path: '/flight-radar', label: 'Flight Radar', summary: 'Live ADS-B map of aircraft near the community.' },
      { match: /earthquake|eathquake|seismic|usgs/, path: '/seismic-monitoring', label: 'Seismic Activity', summary: 'Regional earthquake data from USGS.' },
      { match: /well|groundwater/, path: '/well-monitoring', label: 'Well Monitoring', summary: 'Community well level charts.' },
      { match: /invoice|billing|pay/, path: '/invoices', label: 'My Invoices', summary: 'Pay HOA assessments with Stripe.' },
      { match: /watcher|admin portal/, path: '/admin', label: 'Admin Portal', summary: 'Ops monitoring, watcher, and scheduled jobs.' },
    ];
    const hit = portalHints.find((h) => h.match.test(msg));
    if (hit) {
      const navigate = /\b(take me|go to|navigate|show me|bring me)\b/.test(msg);
      return {
        reply: navigate
          ? `Taking you to ${hit.label} (${hit.path}).`
          : `${hit.label} (${hit.path}): ${hit.summary}`,
        configured: true,
        actionTaken: null,
        navigation: navigate ? { path: hit.path } : null,
      };
    }
    return {
      reply: 'I\'m Nanny, your demo guide. Ask about flight radar, earthquakes, gate access, invoices, or say "take me to…" any menu page.',
      configured: true,
      actionTaken: null,
      navigation: null,
    };
  },
  getAdminApiCatalog: {
    generatedAt: new Date().toISOString(),
    summary: { total: 8, inUse: 7, unused: 1, callables: 5, http: 2, scheduled: 1 },
    surfaces: [
      { name: 'getMailboxStatus', kind: 'callable', section: 'Mailbox', path: 'getMailboxStatus', inUse: true, description: 'Today delivery status' },
      { name: 'getVehicleLog', kind: 'callable', section: 'Vehicle', path: 'getVehicleLog', inUse: true, description: 'Admin vehicle sightings' },
      { name: 'openGate', kind: 'callable', section: 'Gate', path: 'openGate', inUse: true, description: 'Remote gate open for owner lot' },
      { name: 'searchLocalNews', kind: 'http', section: 'Content', path: 'searchLocalNews', inUse: true, description: 'RSS news aggregation' },
      { name: 'syncLocalEvents', kind: 'scheduled', section: 'Calendar', path: 'syncLocalEvents', inUse: true, description: 'Daily event population' },
      { name: 'getAdminOpsSnapshot', kind: 'callable', section: 'Admin', path: 'getAdminOpsSnapshot', inUse: true, description: 'Ops monitoring snapshot' },
      { name: 'getScheduledJobsStatus', kind: 'callable', section: 'Admin', path: 'getScheduledJobsStatus', inUse: true, description: 'Scheduled job status' },
      { name: 'seedVehicleDemo', kind: 'callable', section: 'Admin', path: 'seedVehicleDemo', inUse: false, description: 'QA demo vehicle seed' },
    ],
  },
};

export const DEMO_WEATHER = {
  current: {
    temp: '68°F',
    humidity: '62%',
    wind: '6 mph',
    rawData: {
      imperial: { temp: 68, windSpeed: 6 },
      humidity: 62,
      obsTimeUtc: new Date().toISOString(),
    },
  },
  hourly: {
    observations: Array.from({ length: 24 }, (_, i) => ({
      obsTimeUtc: new Date(now - (23 - i) * 3600000).toISOString(),
      imperial: { temp: 58 + i, windSpeed: 4 + (i % 5), pressure: 30.1 },
      humidity: 55 + (i % 15),
    })),
  },
};